import { cn } from '@/lib/utils';

interface IFieldRowProps {
  label: string;
  description?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

/**
 * A labelled field row (input / list / radios) for non-toggle settings. Pairs
 * with {@link ToggleRow} inside a `divide-y` settings list. Shared across the
 * bot config surfaces.
 */
const FieldRow: React.FC<IFieldRowProps> = ({
  label, description, children, className,
}) => (
  <div className={cn('py-4', className)}>
    <p className="text-sm font-medium text-gray-900">{label}</p>
    {description && <p className="mt-0.5 text-[13px] leading-relaxed text-gray-500">{description}</p>}
    <div className="mt-3">{children}</div>
  </div>
);

export default FieldRow;
